// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Segment, Image } from 'semantic-ui-react'
import objects from '../assets/bee.png'

export default class CTA extends Component {
  render () {
    return (
      <center className='div2 mb'>
        <Segment fluid basic>
          <Image centered src={objects} style={{ maxWidth: 100 }} />
          <br />
          <h2>
            <b>Build your app today</b>
          </h2>
          <h5>Free trial | No limitations | No credit card required!</h5>
          <br />
          <Button.Group>
            <Button
              size='large'
              color='black'
              href='/signup'
              style={{ marginRight: '1vh' }}>
              Get Started
            </Button>
            <Button
              basic
              size='large'
              color='black'
              target='_blank'
              rel='noopener noreferrer'
              style={{ marginRight: '1vh' }}
              href='https://murkstom.kampsite.co/'>
              Feature Requests
            </Button>
          </Button.Group>
        </Segment>
      </center>
    )
  }
}
